module.exports = {
    VISA: 'VISA',
    MASTER_CARD: 'MASTER_CARD',
};
